document.addEventListener("DOMContentLoaded", function () {
    let swiperInstance = null;
    function initializeSwiper() {
      if (window.innerWidth <= 990) {
        if (!swiperInstance) {
          swiperInstance = new Swiper(".swiper-container", {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }
    initializeSwiper();
    window.addEventListener("resize", function () {
      initializeSwiper();
    });

    var swiper = new Swiper(".article-product-swiper", {
      slidesPerView: "auto",
      freeMode: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const links = document.querySelectorAll('a.link[data-blog-tag]');
    const currentPath = window.location.pathname;
    const baseUrl = "/blogs/news";
    links.forEach(function(link) {
      const tag = link.getAttribute('data-blog-tag');

      if (tag) {
        const tagHref = `${baseUrl}/tagged/${tag}`;
        link.setAttribute('href', tagHref);

        link.classList.remove('is-selected');

        if (currentPath === `/blogs/news/tagged/${tag}`) {
          link.classList.add('is-selected');

          document.querySelectorAll('a.link.is-selected').forEach(function(el) {
            if (el !== link) {
              el.classList.remove('is-selected');
            }
          });
        }
      }
    });
  });
